import React, { useRef, useState } from "react";
import editIcon from "../../assets/icons/edit.png"
import brandLogo from "../../assets/parkingHeroLogo.png";
import userProfileimg from "../../assets/icons/icons8-user-64.png";
import burgerMenu from "../../assets/icons/icons8-menu-120.png"
import adimg from "../../assets/icons/adIMG.png"
import Settings from "../../assets/icons/settings.png"
import comments from "../../assets/icons/comments.png"
import "./styles.scss";
import { MenuListComponent } from "../menuList";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Reducer";
import { Link } from "react-router-dom";
import { HeroStatMenuList } from "../heroStatMenuList";

type Tprop = {
    noAds?: boolean;
    editButton?: boolean;
    handleEdit?: () => void;
    Admin?: boolean
    account?:boolean
}

export const Navbar: React.FC<Tprop> = ({ noAds, editButton, handleEdit, Admin ,account}) => {
    const [edit, setEdit] = useState<boolean>(false)
    const token: any = useSelector<RootState>((state) => state?.authData?.authData?.token?.access);
    const [show, setShow] = useState<any>(false)
    const anchorRef = useRef<any>(null);
    const [show2, setShow2] = useState<any>(false)
    const anchorRef2 = useRef<any>(null);
    const anchorRef3 = useRef<any>(null);
    const [show3, setShow3] = useState<any>(false)
    const userData: any = useSelector<RootState>((state) => state?.authData?.authData)
    const message = `Welcome ${userData?.hero_name} ! You can use the buttons below me to Access your QR Code, Referral Code, Check Your Messages, and see your offers`
    const handleEditIcon = () => {
        setEdit(!edit)
        if (handleEdit) { handleEdit() }
    }

    return (
        <div className="navbar .no-print">
            <div className="head-container flex flex-row">
                <div className="logo-wrapper basis-1/4 flex flex-row" >
                    <div className="logo" ref={anchorRef3} onMouseEnter={() => setShow3(true)} onMouseLeave={() => setShow3(false)}>
                        <Link to={'/'}><img src={brandLogo} alt="logo" /></Link>
                    </div>
                    {account && <HeroStatMenuList show={show3} logo={true} setShow={setShow3} position={"left top"} anchorRef={anchorRef3} message={message} />}
                </div>
                {noAds ? <div className="ad-container basis-2/4 flex flex-row"></div> :
                    <div className="ad-container basis-2/4 flex flex-row">
                        <img src={adimg} alt="adimg" />
                    </div>}

                {!Admin && <div className="end-icons basis-1/4 flex flex-row-reverse">
                    <button>
                        <img src={burgerMenu} onClick={() => setShow(!show)} ref={anchorRef} alt="burger" />
                        <MenuListComponent show={show} setShow={setShow} anchorRef={anchorRef} profile="menu" />
                    </button>
                    {token && <button>
                        <img src={userProfileimg} onClick={() => setShow2(!show2)} ref={anchorRef2} alt="profile" />
                        <MenuListComponent show={show2} setShow={setShow2} anchorRef={anchorRef2} profile="profile" />
                    </button>}
                    {editButton &&
                        <button type="submit" onClick={handleEditIcon} className="edit-icon">
                            <img style={{ filter: edit ? "invert(81%) sepia(8%) saturate(749%) hue-rotate(88deg) brightness(86%) contrast(83%)" : "", }} src={editIcon} alt="edit-icon" />
                        </button>}
                </div>}
                {Admin && <div className="end-icon basis-1/4 flex flex-row-reverse">
                    <button>
                        <img src={comments} onClick={() => setShow(!show)} ref={anchorRef} alt="comments" />
                    </button>
                    <button>
                        <img src={Settings} onClick={() => setShow2(!show2)} ref={anchorRef2} alt="settings" />
                        <MenuListComponent show={show2} setShow={setShow2} anchorRef={anchorRef2} profile="settings" />
                    </button>
                </div>}
            </div>
        </div>
    )
}